var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"group_skills_popup",on:{"click":_vm.close}}),_c('div',{staticClass:"main"},[_c('span',{staticClass:"title"},[_vm._v("拼团小技巧")]),_c('p',{staticClass:"txt1"},[_vm._v("分享到3个家长群，")]),_vm._m(0),_c('button',{on:{"click":_vm.share}},[_vm._v("继续分享")])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"txt2"},[_vm._v("拼团"),_c('span',[_vm._v("成功率高达 95%")])])
}]

export { render, staticRenderFns }